<template>
  <Modal
    name="CONFIRM_CHARGE_PAYMENT_MODAL"
    :title="title"
    :width="600"
    actions
  >
    <template v-slot:body>
      <div class="mw-400 mb-5">
        <p class="mb-1">{{ $t('charge.hint.wantToPay') }}</p>
        <small>{{ $t('charge.hint.fci') }}</small>
      </div>
      <v-card class="pa-5" color="grey lighten-4" elevation="0">
        <!-- single payment -->
        <div v-if="charge">
          <div class="d-flex">
            <span class="d-block mr-10">
              <h6 class="text-uppercase grey--text">
                {{ $t('charge.label.code') }}
              </h6>
              <p class="body-2">
                {{ charge.code }}
              </p>
            </span>
            <span>
              <h6 class="text-uppercase grey--text">
                {{ $t('charge.label.amount') }}
              </h6>
              <p class="body-2">
                {{ charge.value ? formatMoney(charge.value) : '---' }}
              </p>
            </span>
          </div>

          <h6 class="text-uppercase grey--text">
            {{ $t('charge.label.payer') }}
          </h6>

          <p class="body-2 mb-0">
            {{ charge.payer.real_estate.name }}
          </p>
        </div>
        <!-- /single payment -->

        <!-- bulk payment -->
        <div v-if="charges.length >= 1">
          <h6 class="text-uppercase grey--text">
            {{ $t('charge.label.totalAmountToPay') }}
          </h6>
          <p class="mb-0 body-2">
            {{ totalToPay ? formatMoney(totalToPay) : '---' }}
          </p>

          <v-divider class="my-4" />

          <v-data-table
            :items="charges"
            :headers="chargesHeader"
            hide-default-footer
            disable-sort
          >
            <template v-slot:[`item.value`]="{ item }">
              {{ item.value ? formatMoney(item.value) : '---' }}
            </template>
          </v-data-table>
        </div>
        <!-- /bulk payment -->
      </v-card>
    </template>
    <template v-slot:actions>
      <v-btn
        @click="closeAllModals"
        :disabled="isBeingPaid"
        class="mr-5"
        large
        text
      >
        {{ $t('itemPrice.action.cancel') }}
      </v-btn>

      <v-btn
        @click="confirmPayment"
        :loading="isBeingPaid"
        elevation="0"
        color="primary"
        large
        dark
      >
        {{ $t('charge.label.payUsingBalance') }}
      </v-btn>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/app/Modal'

import { catalogMonetary } from '@/util/catalog'
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'ChargeConfirmPayment',

  components: {
    Modal,
  },

  props: {
    charge: {
      type: Object,
    },

    charges: {
      type: Array,
    },

    totalToPay: {
      type: [String, Number],
    },

    parsedCharges: {
      type: Array
    }
  },

  computed: {
    ...mapGetters(['isBeingPaid']),
  },

  methods: {
    ...mapMutations(['closeAllModals']),
    ...mapActions(['doPayment']),

    confirmPayment() {
      this.doPayment(this.charge ? [this.charge?.id] : this.parsedCharges)
        .then(() => this.$parent?.resetSelected())
    },
  },

  data() {
    return {
      formatMoney: catalogMonetary,
      title: this.$t('charge.label.confirmPayment'),
      chargesHeader: [
        {
          text: this.$t('charge.label.amount'),
          value: 'value'
        },
        {
          text: this.$t('charge.label.payer'),
          value: 'payer.real_estate.name'
        },
      ]
    }
  },
}
</script>
